// Internal dependencies
import { RewriteIconSG, WritingIconSG, SummarizeIconSG, TranslateIconSG, MakeShorterIconSG, MakeLongerIconSG, SimplifyIconSG, CheckIconSG, } from '../components/icons';
export const EDITOR_COMMAND_TYPES = {
    REWRITE_IMPROVE: 'Rewrite & Improve',
    CONTINUE_WRITING: 'Continue writing',
    SUMMARIZE: 'Summarize',
    TRANSLATE: 'Translate',
    RUN_COMMAND: 'Run command',
    MAKE_SHORTER: 'Make shorter',
    MAKE_LONGER: 'Make longer',
    SIMPLIFY_LANGUAGE: 'Simplify Language',
    FIX_GRAMMAR: 'Fix grammar',
};
export const EDITOR_COMMANDS = [
    {
        type: EDITOR_COMMAND_TYPES.REWRITE_IMPROVE,
        Icon: RewriteIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.CONTINUE_WRITING,
        Icon: WritingIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.MAKE_SHORTER,
        Icon: MakeShorterIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.MAKE_LONGER,
        Icon: MakeLongerIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.SUMMARIZE,
        Icon: SummarizeIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.TRANSLATE,
        Icon: TranslateIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.SIMPLIFY_LANGUAGE,
        Icon: SimplifyIconSG,
    },
    {
        type: EDITOR_COMMAND_TYPES.FIX_GRAMMAR,
        Icon: CheckIconSG,
    },
    /*
    {
      type: EDITOR_COMMAND_TYPES.RUN_COMMAND,
      Icon: RunIconSG,
    },
    */
];
